export const SET_USED_TEF = 'TEF/SET_USED_TEF';
